module.exports = __webpack_public_path__ + "img/movenpick.9bf06fe7.jpg";